import LegalPage, {
  SectionTitleTypography,
  TermTypography,
} from "../../../common/components/LegalPage"

export default function TermsAndConditions() {
  return (
    <LegalPage title="Terms and Conditions">
      <SectionTitleTypography>User Responsibilities</SectionTitleTypography>
      <TermTypography>
        You are responsible for ensuring that any content you post on OneBase®,
        including job opportunities and compensation contracts, is between you
        and the Candidate and does not involve OneBase® as a party. By using
        OneBase®, you agree not to post any content that is discriminatory,
        defamatory, obscene, or otherwise offensive. Regardless of whether you
        are an agent or a brokerage representative, as a OneBase® user you
        represent and warrant that any data entered into the website for the
        purposes of evaluation by others, including but not limited to your
        personal information, work experience, education, brokerage offerings,
        compensation, company history, photos, videos, accreditations, and
        skills, is truthful and accurate to the best of your knowledge, and does
        not misrepresent the opportunity being advertised.
        <EmptyLine />
        You acknowledge that this information may be used by other users to
        evaluate the contemplated proposals or job offers, and therefore agree
        to ensure its accuracy and completeness. We shall not be responsible for
        any inaccuracies or omissions in your data and reserve the right to
        suspend or terminate your account if such inaccuracies or omissions are
        discovered.
        <EmptyLine />
        We reserve the right to reject, remove, or limit visibility to any User
        Content at our sole discretion, with or without notice to you who posted
        such content. This includes content that we determine, in our sole
        discretion, to be in violation of these Terms and Conditions, or that we
        believe is illegal, fraudulent, or otherwise harmful to our platform or
        its users. We shall have no liability to any user or third party for any
        such action taken by us. By using our platform, you agree to receive
        marketing, security, and account management communications from us via
        email and text message. You may opt out of marketing communications at
        any time by clicking the unsubscribe link in our emails or by replying
        STOP to our text messages. However, please note that opting out of
        marketing communications will not affect your receipt of important
        security and account management messages.
      </TermTypography>
      <SectionTitleTypography>
        Liability and Indemnification
      </SectionTitleTypography>
      <TermTypography>
        We are not responsible for the content posted on OneBase® by users. We
        do not endorse or guarantee the accuracy, completeness, or usefulness of
        any content posted on OneBase®, including regarding compensation offers
        or other third-party claims. By using OneBase®, you agree to indemnify
        and hold us harmless from any claims, damages, or losses arising from
        your use of OneBase® or any content you post on OneBase®.
        <EmptyLine />
        Further to that, all proposals, offers, negotiations, and similar claims
        or advertisements encountered on the site are strictly non-binding and
        should be used only for evaluation purposes.Users who request anonymity
        on OneBase® understand and agree that OneBase® cannot guarantee absolute
        confidentiality or anonymity. While OneBase® will take reasonable
        measures to protect your identity, you acknowledge that there may be
        circumstances where your identity may be discovered. You agree to
        indemnify and hold OneBase® harmless from any claims, damages, or
        liabilities arising out of your request for anonymity, including but not
        limited to any identity disclosures that may occur.
        <EmptyLine />
        OneBase® cannot guarantee the accuracy or completeness of any
        recommendations or predictive statistical data provided to users,
        including trends, market averages for compensations, or other analysis
        tools intended to help users make more informed decisions. You
        acknowledge that such data is provided for informational purposes only
        and that OneBase® is not responsible for any inaccuracies or omissions.
        You agree to use the data at your own risk and to indemnify and hold
        OneBase® harmless from any claims or losses arising from your use of
        such data.
      </TermTypography>
      <SectionTitleTypography>Intellectual Property</SectionTitleTypography>
      <TermTypography>
        All content on OneBase®, including text, graphics, logos, and software,
        is the property of OneBase® or its licensors and is protected by
        copyright and other intellectual property laws. You may not reproduce,
        modify, or distribute any content on OneBase® without our prior written
        permission.
        <EmptyLine />
        By using our website, you also agree to allow us to store, analyze, and
        process any data you enter into the website, including personal
        information, communications, and other content. We may use this data to
        improve our services, provide personalized content and marketing, and
        ensure the security of our website and users. We may also share this
        data with third-party service providers who assist us in these efforts.
        Rest assured that we take reasonable measures to protect your data and
        will not knowingly share it with any unauthorized parties.
      </TermTypography>
      <SectionTitleTypography>Disclaimer of Warranties</SectionTitleTypography>
      <TermTypography>
        These Terms will be governed by and construed following the laws of
        Ontario, Canada. Any disputes arising from these Terms will be subject
        to the exclusive jurisdiction of the courts in Toronto, Canada.
      </TermTypography>
      <SectionTitleTypography>Changes to Terms</SectionTitleTypography>
      <TermTypography>
        We reserve the right to modify these Terms at any time, without prior
        notice. Your continued use of OneBase® after any such modifications will
        constitute your acceptance of the new Terms.
      </TermTypography>
      <SectionTitleTypography>Contact Us</SectionTitleTypography>
      <TermTypography>
        If you have any questions about these Terms, please contact us at{" "}
        <a href="tel:+1 (800)-432-9159">1 (800)-432-9159</a>.<br />
        By using OneBase®, you agree to these Terms and Conditions.
      </TermTypography>
    </LegalPage>
  )
}

function EmptyLine() {
  return (
    <>
      <br />
      <br />
    </>
  )
}
